import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { Container } from 'components/atoms/container'

export const StyledCategoryPage = styled.div`
  background-color: ${theme.colors.white};
  .article-bottom-ad {
    margin-bottom: var(--mobile-bottom-height);
    @supports (margin-bottom: env(safe-area-inset-bottom)) {
      margin-bottom: calc(
        env(safe-area-inset-bottom) + var(--mobile-bottom-height)
      );
    }
    ${MediaQueries.mbUp} {
      margin-bottom: 0px;
    }
  }
`

export const StyledCategoryContainer = styled(Container)`
  &[data-type-mobile='false'] {
    padding: 0 16px;
  }

  ${MediaQueries.mbDown} {
    .banner-ad {
      margin-top: 24px;
      margin-bottom: 24px;
      text-align: center;
    }
  }

  .top-ad {
    margin-left: auto;
    margin-right: auto;
    margin-top: 24px;
  }
  .category-side-ad {
    margin: 0 auto;
    :not(:last-child) {
      margin-bottom: 1rem;
    }
  }
  .middle-ad {
    margin-bottom: 40px;
  }
`

export const StyledCategoryArticleWrapper = styled.div`
  display: flex;

  .right-section {
    .top-ad,
    .bottom-ad {
      margin-left: auto;
      margin-right: auto;
    }
  }
  ${MediaQueries.mbDown} {
    .right-section {
      margin-top: 2rem;
    }
  }

  ${MediaQueries.mbUp} {
    .banner-ad {
      position: relative;
      display: flex;
      width: calc(300px + 3%);
      flex-direction: column;
      justify-content: space-between;
      padding-left: 3%;
      .top-ad {
        margin-bottom: 2rem;
      }
      .bottom-ad {
      }
    }

    .right-section {
      width: 36%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .community-container {
        max-width: 342px;
        .grid-layout {
          padding: 0 8px;
        }
      }
      .top-ad,
      .bottom-ad {
        margin-bottom: 2rem;
      }
      .sticky-ad {
        position: sticky;
        top: 130px;
      }
      .desktop-ad {
        margin-left: auto;
        margin-right: auto;
        ${MediaQueries.mbUp} {
          padding: 1rem 0;
          position: sticky;
          top: 130px;
        }
      }
    }
  }

  &[data-type-mobile='false'] {
    flex-direction: row;
    margin: 80px 0 60px;

    .articles {
      width: calc(100% - 300px - 8%);
    }

    .pagination {
      margin-top: 10px;
      margin-right: auto;
      margin-left: auto;
    }
  }

  &[data-type-mobile='true'] {
    flex-direction: column;

    .pagination {
      margin-top: 10px;
    }
  }
`

export const StyledSponsored = styled.div`
  &[data-type-mobile='true'] {
    width: 100%;
  }

  &[data-type-mobile='false'] {
    width: 768px;
    margin: 0 auto;
  }
`

export const StyledPregnancyWeek = styled.div`
  width: 100vw;
  margin-left: min(calc(585px - 50vw - 15px), 0px);
  margin-bottom: 64px;

  ${MediaQueries.mbDown} {
    margin-left: -16px;
    margin-bottom: 48px;
  }
`

export const StyledFaqDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
